<template>
  <div v-if="body_show" class="he-review-box">
    <ul class="he-review">
      <li class="li">
        <img :src="data.headimgurl" class="img" />
        <div class="content">谢谢你！帮我完成了能力优势的TA评环节！你也获得了一次免费《职业发展健康指数测评》的机会，帮你从「职业幸福感」、「职业掌控度」、「心智成熟度」三大维度更好的了解当下职业健康状态~</div>
      </li>
      <li class="li">
        <img :src="data.headimgurl" class="img" />
        <div class="content">
          长按识别下方二维码，即可进入测评
          <img class="ewm" src="@a/ewms.png" />
        </div>
      </li>
      <li class="li on">
        <img :src="data.headimgurl" class="img" />
        <div  class="content">
          <div class="career-dev">
              <public-advertising></public-advertising>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { gettitle} from "@/api/measurement";
import { shareCon } from "@/utils/wxconfig";
import PublicAdvertising from "@c/measurement/public-advertising";
export default {
  data() {
    return {
      data: {},
      body_show: false
    };
  },
  components:{
    PublicAdvertising
  },
  methods: {
    pullData() {
      let cid = this.$route.query.cid;
      gettitle({
        cid: cid,
        uid: this.$route.query.uid
      }).then(data => {
        this.body_show = true;
        document.title = data.headtitle;
        this.data = data;
      });
    }
  },
  created() {
    this.pullData();
    shareCon("measurement", this);
  }
};
</script>

<style lang="scss" scoped>
.he-review-box {
  .to-review {
    display: block;
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    line-height: 98px;
    background-color: #eb5032;
    color: #fff;
    border: none;
    font-size: 34px;
  }
  .he-review {
    padding: 40px 30px 100px 30px;
  }
  .he-review {
    .li {
      font-size: 0;
      margin-bottom: 60px;
    }
    .li.on {
      margin-bottom: 0;
    }
    img.img {
      display: inline-block;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      vertical-align: top;
    }
    .content {
      display: inline-block;
      width: 520px;
      background: #f57f17;
      border-radius: 8px;
      padding: 20px;
      line-height: 42px;
      color: #ffffff;
      font-size: 26px;
      margin-left: 28px;
      position: relative;
      img.ewm {
        width: 214px;
        height: 214px;
        margin-top: 14px;
      }
    }
    .content:after {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      top: 20px;
      left: -14px;
      border-top: 10px solid rgba(245, 127, 23, 0);
      border-right: 15px solid rgba(245, 127, 23, 1);
      border-bottom: 10px solid rgba(245, 127, 23, 0);
    }
  }
}
// 9.9职业发展广告
.career-dev {
  .More-main {
    background-color: #ffffff;
    padding: 20px;
    .title {
      text-align: center;
      margin-bottom: 30px;
      font-size: 34px;
      color: #333333;
      padding-bottom: 20px;
      border-bottom: 1px solid #cccccc;
    }
    ul {
      display: flex;
      flex-direction: column;
      li {
        display: flex;
        flex-direction: column;
        h3 {
          font-weight: bold;
          font-size: 30px;
          line-height: 40px;
          text-align: left;
          color: #333333;
          padding-bottom: 20px;
          border-bottom: 2px solid #fff;
        }
        img {
          width: 282px;
          height: 176px;
          border: 1px solid #ffffff;
          margin: 0 auto 20px;
          // margin-bottom: 20px;
        }
        .flex-text {
          flex: 1;
          border-top: 1px solid #cccccc;
          display: flex;
          a {
            display: block;
            border-radius: 25px;
            background-color: #eb5032;
            color: #ffffff;
            width: 188px;
            line-height: 50px;
            margin: 15px auto 0;
            font-size: 26px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
